import { render } from "./ReportBug.vue?vue&type=template&id=42db81c6&scoped=true"
import script from "./ReportBug.vue?vue&type=script&lang=js"
export * from "./ReportBug.vue?vue&type=script&lang=js"

import "./ReportBug.vue?vue&type=style&index=0&id=42db81c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42db81c6"]])

export default __exports__